import client from "./client";

const textCard = (card = {}) => ({
  title: card.title || "",
  description: card.description || "",
});

const pillarCard = (card = {}) => ({
  n: card.n || "",
  title: card.title || "",
  description: card.description || "",
});

const statCard = (card = {}) => ({
  number: card.number || "",
  label: card.label || "",
});

const faqCard = (card = {}) => ({
  question: card.question || "",
  answer: card.answer || "",
});

const TEXT_KEYS = [
  "heroTag",
  "heroTitle1",
  "heroTitle2",
  "heroDescription",
  "heroPrimaryCtaText",
  "heroPrimaryCtaLink",
  "heroSecondaryCtaText",
  "heroSecondaryCtaLink",
  "heroTrustText",
  "buildTag",
  "buildTitleLead",
  "buildTitleAccent",
  "buildTitleTail",
  "buildBody",
  "faqTag",
  "faqTitleLead",
  "faqTitleAccent",
];

const BOOL_KEYS = ["heroSectionHide", "buildHide", "statsHide", "faqHide"];
const PILLAR_KEYS = ["pillar1", "pillar2", "pillar3"];
const STAT_KEYS = ["stat1", "stat2", "stat3", "stat4"];

const packLogo = (card = {}) => ({
  image: card.image || "",
  text: card.text || "",
});

export function preparePricingPage(form = {}) {
  const payload = {};

  TEXT_KEYS.forEach((key) => {
    if (form[key] !== undefined) payload[key] = form[key] ?? "";
  });
  BOOL_KEYS.forEach((key) => {
    if (form[key] !== undefined) payload[key] = !!form[key];
  });

  if (form.heroLogoCard !== undefined) payload.heroLogoCard = packLogo(form.heroLogoCard);
  if (form.heroCard1 !== undefined) payload.heroCard1 = textCard(form.heroCard1);
  if (form.heroCard2 !== undefined) payload.heroCard2 = textCard(form.heroCard2);

  PILLAR_KEYS.forEach((key) => {
    if (form[key] !== undefined) payload[key] = pillarCard(form[key]);
  });
  STAT_KEYS.forEach((key) => {
    if (form[key] !== undefined) payload[key] = statCard(form[key]);
  });
  if (form.faqItems !== undefined) {
    payload.faqItems = (form.faqItems || []).map(faqCard);
  }

  return payload;
}

export const getPricingPage = () => client.post("/pricingpage/getPage");
export const addPricingPage = (payload) =>
  client.post("/pricingpage/addpage", payload);
export const updatePricingPage = (payload) =>
  client.post("/pricingpage/updatePage", payload);
